// extracted by mini-css-extract-plugin
export default {"root":"Analytics_root__Nftxu","tiles":"Analytics_tiles__xe2AB","content":"Analytics_content__DCVeE"};